import { useQuery } from "@tanstack/react-query";
import adminApiClient from "../../api/admin";

export const useNumberOfAuthorsCreatedKlydos = () => {
  return useQuery<number>({
    queryKey: ["klydosCreatedByAuthors"],
    queryFn: async () => {
      return adminApiClient.getNumberOfArtistsCreatedKlydos();
    },
  });
};
